import Image from 'next/image';

export function EkutuQrLogo({
	size = 'default',
	showText = true,
	variant = 'light',
	className,
}: {
	size?: 'sm' | 'default' | 'lg';
	showText?: boolean;
	showSubbrand?: boolean;
	variant?: 'light' | 'dark';
	className?: string;
}) {
	const dims = {
		sm: showText
			? { width: 115, height: 28, class: 'h-7 w-auto' }
			: { width: 24, height: 24, class: 'size-6' },
		default: showText
			? { width: 148, height: 36, class: 'h-9 w-auto' }
			: { width: 32, height: 32, class: 'size-8' },
		lg: showText
			? { width: 181, height: 44, class: 'h-10 sm:h-11 w-auto' }
			: { width: 40, height: 40, class: 'size-10' },
	}[size];

	const src = showText
		? variant === 'dark'
			? '/logo-full-dark.png'
			: '/logo-full-light.png'
		: '/logo-icon.png';

	return (
		<span className={`inline-flex items-center select-none ${className ?? ''}`}>
			<Image
				src={src}
				alt="Ekutu QR"
				width={dims.width}
				height={dims.height}
				unoptimized
				priority
				className={`${dims.class} object-contain`}
			/>
		</span>
	);
}
